import { last, includes } from 'lodash';

export const getAttachmentType = (url: string) => last(url.split('.'));
export const getAttachmentFilename = (url: string) => last(url.split('/'));
export const isAttachmentImage = (attachmentType?: string) => includes(['jpg', 'jpeg', 'png'], attachmentType);
export const isAttachmentPdf = (attachmentType?: string) => attachmentType === 'pdf';
